<template>
  <div class="comtainer-main">
    <div class="layout-main" v-if="show">
      <div :class="payType==1?'zfb-succeed':'wx-succeed'">
            <van-icon name="checked zfb-ico" v-if="middle" />
            <van-icon name="checked fail" v-else />
            <h2 class="succeed-text">{{middle?'支付成功':'支付失败'}}</h2>
            <span class="succeed-time">{{total}}秒后自动返回首页</span>
            <van-button :payType="payType==1?'info':'primary'"  class="get-back-btn" @click="getBackBtn">立即返回</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions} from "vuex";
export default {
  name: 'paymentSuccess',
  components: {
  },
  mounted () {
     let orderNo = this.$route.query.out_trade_no;
    // 支付成功回调 查询订单payType  支付微信   orderNo订单号 
    let data ={
      orderNo:orderNo,
      payType:1
    }
    this.$api.good.queryOrderl(data).then((res)=>{
       this.show=true
        if(res.code=='10000'){
           this.clock=window.setInterval(() => {
              if(this.total<=1){
                window.clearTimeout(this.clock)
               this.$router.push({
                 name:this.routerUrl
               })
              }
              this.total--
            },1000)
          this.middle=true
          this.getUserMoney()
        }else{
            this.clock=window.setInterval(() => {
              if(this.total<=1){
                window.clearTimeout(this.clock)
               this.$router.push({
                 name:this.routerUrl
               })
                // this.$router.go(-1)
              }
              this.total--
            },1000)
            this.getUserMoney()
            this.middle=false
        }
    }).catch((err) =>{ 
        this.middle=false
        this.clock=window.setInterval(() => {
              if(this.total<=1){
               window.clearTimeout(this.clock)
               this.$router.push({
                 name:this.routerUrl
               })
              }
              this.total--
         },1000)
        this.show=true
        console.log(err.data)
    })
  },
  created() {

  },
  data () {
    return {
      clock:null,
      show:false,
      total:10,
      routerUrl:"home",
      payType:1,
      orderNo:"",
      middle:true
    }
  },
  beforeDestroy() {
    if(this.clock) {
      window.clearTimeout(this.clock);
    }
  },
  methods: {
    ...mapActions(['getUserMoney']),
    getBackBtn(){
      this.$router.push({
         name:this.routerUrl
      })
    }
  }
}
</script>
<style  scoped>
.zfb-succeed{
  text-align: center;
  padding-top: 30vh;
}
.zfb-succeed .get-back-btn{
  width: 130px;
  
}
.zfb-succeed .succeed-text{
  margin: 10px;
  font-size: 14px;
  display: block;
}
.zfb-succeed .succeed-time{
   margin: 10px;
   font-size: 13px;
   display: block;
}
.zfb-succeed .zfb-ico{
   font-size: 64px;color:#00a3ee;
 }
.zfb-succeed  /deep/ .get-back-btn{
    background-color:#00a3ee;
    border-color:#00a3ee ;
    color: #fff;
}
.wx-succeed{
  text-align: center;
  padding-top: 30vh;
}
.wx-succeed .get-back-btn{
  width: 130px;
  
}
.wx-succeed .succeed-text{
  margin: 10px;
  font-size: 14px;
  display: block;
}
.wx-succeed .succeed-time{
   margin: 10px;
   font-size: 13px;
   display: block;
}
.wx-succeed .zfb-ico{
   font-size: 64px;color:#0db903;
 }
.wx-succeed  /deep/ .get-back-btn{
    background-color:#0db903;
    border-color:#0db903 ;
    color: #fff;
}
.fail{
   font-size: 64px;
   color: red;
}
</style>